import { useSnackbar } from "notistack";
import * as React from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import useAuth from "../../core/hooks/useAuth";
import { PermissionsType } from "../../core/models/Permission";
import { SessionCache } from "../../helpers/cache";
import { isArrayValid } from "../../helpers/utility";

/* eslint-disable @typescript-eslint/no-explicit-any*/
type ProtectedRouteProps = {
  permissionType: PermissionsType | PermissionsType[];
  component?: any;
  children?: React.ReactNode;
} & any;
/* eslint-enable @typescript-eslint/no-explicit-any*/

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { component: Component, children, permissionType, ...rest } = props;
  const authProvider = useAuth();
  const isAuthenticated = authProvider.get();
  let hasPermission = false;
  let blockedByScreenSize = false;
  const cache = new SessionCache();
  const toastr = useSnackbar();

  if (isArrayValid(permissionType)) {
    hasPermission = authProvider.hasAnyPermission(permissionType);
    blockedByScreenSize = authProvider.mobileRestriction(permissionType);
  } else {
    hasPermission = authProvider.hasPermission(permissionType);
    blockedByScreenSize = authProvider.mobileRestriction([permissionType]);
  }

  if (isAuthenticated && !hasPermission) {
    toastr.enqueueSnackbar("Ops! Seu usuário não possuí acesso para esta feature!", {
      variant: "warning",
    });
  }

  if (isAuthenticated && hasPermission && blockedByScreenSize) {
    toastr.enqueueSnackbar("Ops! Esta feature só está disponível na versão web da aplicação!", {
      variant: "info",
    });
  }

  const AuthorizationChecker = (location: any) => {
    if (isAuthenticated) {
      let prevLocale: any = cache.get<string>("previousLocale");
      if (prevLocale) {
        cache.delete("previousLocale");
        return <Redirect
          to={{
            pathname: prevLocale
          }} />
      }
      return <Redirect
        to={{
          pathname: "/home/",
          state: { from: location },
        }} />;
    }

    cache.set("previousLocale", location.pathname);

    return <Redirect
      to={{
        pathname: "/",
        state: { from: location },
      }}
    />;
  }

  if (!Component && children) {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          isAuthenticated === true && hasPermission === true && blockedByScreenSize === false ? (
            children
          ) : AuthorizationChecker(location)
        }
      />
    );
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated === true && hasPermission === true && blockedByScreenSize === false ? (
          <Component {...rest} />
        ) : AuthorizationChecker(location)
      }
    />
  );
};
export default ProtectedRoute;
